import styled from 'styled-components'

export const ErrorWrapper = styled.div`
  padding-bottom: 10px;
`
